import React, { useState, useEffect } from 'react';
import { supabase } from '../../supabaseClient';

const Tutorial = ({ tutorialId, userId, pasos = [], botonVerDeNuevo = false, onFin }) => {
  const [paso, setPaso]         = useState(0);
  const [visible, setVisible]   = useState(false);
  const [cargando, setCargando] = useState(true);

  useEffect(() => {
    const verificar = async () => {
      if (!userId || !tutorialId) { setCargando(false); onFin?.(); return; }
      const { data } = await supabase
        .from('perfiles').select('tutoriales_vistos').eq('id', userId).single();
      const vistos = data?.tutoriales_vistos || [];
      if (!vistos.includes(tutorialId)) {
        setVisible(true);
      } else {
        onFin?.(); // ya visto → avisar inmediatamente para que arranque el timer
      }
      setCargando(false);
    };
    verificar();
  }, [tutorialId, userId]); // eslint-disable-line

  const cerrar = async () => {
    setVisible(false);
    onFin?.(); // avisar que terminó
    await supabase.rpc('marcar_tutorial_visto', { p_user_id: userId, p_tutorial_id: tutorialId });
  };

  const verDeNuevo = async () => {
    const { data } = await supabase.from('perfiles').select('tutoriales_vistos').eq('id', userId).single();
    const vistos = (data?.tutoriales_vistos || []).filter(t => t !== tutorialId);
    await supabase.from('perfiles').update({ tutoriales_vistos: vistos }).eq('id', userId);
    setPaso(0);
    setVisible(true);
  };

  const siguiente = () => {
    if (paso < pasos.length - 1) setPaso(paso + 1);
    else cerrar();
  };

  if (cargando || pasos.length === 0) return null;

  const actual = pasos[paso];
  const esFinal = paso === pasos.length - 1;

  return (
    <>
      {/* Botón "Ver tutorial de nuevo" */}
      {botonVerDeNuevo && !visible && (
        <button onClick={verDeNuevo} style={{
          position: 'fixed', bottom: '20px', left: '20px',
          background: '#0f172a', border: '1px solid #00f2ff44',
          borderRadius: '20px', color: '#00f2ff88', fontSize: '0.75rem',
          padding: '6px 14px', cursor: 'pointer', zIndex: 9998,
          transition: '0.2s',
        }}
        onMouseEnter={e => e.currentTarget.style.color = '#00f2ff'}
        onMouseLeave={e => e.currentTarget.style.color = '#00f2ff88'}
        >
          Tutorial
        </button>
      )}

      {/* Modal */}
      {visible && (
        <div style={{
          position: 'fixed', inset: 0,
          background: 'rgba(0,0,0,0.75)',
          backdropFilter: 'blur(4px)',
          zIndex: 999999,
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          padding: '20px',
        }}>
          <div style={{
            background: '#0f172a',
            border: '1px solid #00f2ff44',
            borderRadius: '16px',
            padding: '40px 36px',
            maxWidth: '560px',
            width: '100%',
            boxShadow: '0 0 40px rgba(0,242,255,0.15)',
            position: 'relative',
          }}>
            {/* Skip */}
            <button onClick={cerrar} style={{
              position: 'absolute', top: '14px', right: '16px',
              background: 'none', border: 'none', color: '#a1a2a4',
              cursor: 'pointer', fontSize: '0.88rem', letterSpacing: '1px',
            }}>
              SALTAR ✕
            </button>

            {/* Barra de pasos */}
            {pasos.length > 1 && (
              <div style={{ display: 'flex', gap: '4px', marginBottom: '20px' }}>
                {pasos.map((_, i) => (
                  <div key={i} style={{
                    flex: 1, height: '3px', borderRadius: '2px',
                    background: i <= paso ? '#00f2ff' : '#1e293b',
                    transition: '0.3s',
                  }} />
                ))}
              </div>
            )}

            {/* Contenido */}
            <div style={{ textAlign: 'center', marginBottom: '24px' }}>
              {actual.emoji && (
                <div style={{ fontSize: '3.2rem', marginBottom: '12px' }}>{actual.emoji}</div>
              )}
              <h3 style={{ color: '#00f2ff', margin: '0 0 10px', fontSize: '1.4rem', letterSpacing: '1px' }}>
                {actual.titulo}
              </h3>
              <p style={{ color: '#94a3b8', fontSize: '1.1rem', lineHeight: 1.6, margin: 0 }}>
                {actual.texto}
              </p>
            </div>

            {/* Botón */}
            <button onClick={siguiente} style={{
              width: '100%', padding: '12px',
              background: esFinal ? '#00f2ff' : '#00f2ff22',
              border: '1px solid #00f2ff',
              borderRadius: '8px',
              color: esFinal ? '#000' : '#00f2ff',
              fontWeight: 'bold', fontSize: '1.1rem',
              cursor: 'pointer', transition: '0.2s',
            }}>
              {esFinal ? '¡Entendido!' : 'Siguiente →'}
            </button>
          </div>
        </div>
      )}
    </>
  );
};

export default Tutorial;